import type { IconData } from '@stacksjs/iconify-core'

export const chevronsDownLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 12h7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0zm4-4h7a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronsDownLeft
